import { isMobileOnly } from 'react-device-detect';

export const getHyphenatedPhoneNumber = (phone: string): string => {
  const phoneNumber = phone.replace(/\D/g, '');
  const phoneLength = phoneNumber.length;

  if (phoneLength > 3 && phoneLength <= 6) {
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3)}`;
  }

  if (phoneLength > 6) {
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
      3,
      6,
    )}-${phoneNumber.substring(6, 10)}`;
  }

  return phoneNumber;
};

export const getChannelID = (): number => (isMobileOnly ? 2 : 1);
export const isSsr = typeof window === 'undefined';

export const getUrlParam = (key: string) => {
  const searchParams =
    typeof window !== 'undefined' ? window.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const redirectToSignIn = (): void => {
  if (typeof window !== 'undefined') {
    window.location.replace(
      `/auth/view/signin?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`,
    );
  }
};

export const timeout = (ms: number) => {
  return new Promise((__, reject) =>
    setTimeout(() => reject(new Error('Timeout after ' + ms + ' ms')), ms),
  );
};

export const getCustomerIp = (): string => window.trueClientIp;
